var swiper = new Swiper("#swiper-investors", {
	slidesPerView: 1,
	autoWidth: true,
	navigation: {
		nextEl: "#swiper-button-next",
		prevEl: "#swiper-button-prev",
	},
	pagination: {
		el: "#swiper-pagination",
		clickable: true,
	},
	breakpoints: {
		768: {
			slidesPerView: 4,
			spaceBetween: 10,
		}
	}

});